<div class="pt-2 mt-3 nowork" *ngIf="rsf">
  <div class="row no-gutters">
    <div class="col-6">
      <h5 class="section-title">{{ noWorkPerformedTitle }}</h5>
    </div>
    <div class="col red small">
      <span class="float-right">{{ noWorkPerformedLegend }}</span>
    </div>
  </div>

  <div class="row justify-content-center">
    <form-workflow
      class="full-width"
      [form]="rsf"
      [sectionNumber]="3"
      [disabled]="disabled"
      [overrideDisabledStep]="true"
      [service]="service"
      [hideTitle]="true"
    ></form-workflow>
  </div>
</div>
